import React, {useEffect, useState} from "react";
import FCMNotificationCard from "./FCMNotificationCard";
import {onFCMMessage, requestFCMPermissionAndToken} from "../firebase/fcm";
import secureLocalStorage from "react-secure-storage";
import {REACT_APP_FCM_URL} from "../env";
import {useDispatch} from "react-redux";
import {refreshDatumOrders} from "../actions";

export default function FCMListener() {
  const [notification, setNotification] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    requestFCMPermissionAndToken()?.then(token => {
      if (token) {
        console.log(token);
        return secureLocalStorage.setItem('fcmToken', token);
      } else {
        console.warn("No FCM token received");
      }
    }).catch(error => {
      console.error(error)
    });

    onFCMMessage(payload => {
      // Native browser notification
      const title = payload.notification?.title || payload.data?.title || 'Notification';
      const options = {
        body: payload.notification?.body || payload.data?.body || '',
        icon: payload.notification?.image || payload.data?.image || '/logo192.png',
        data: payload.data
      };
      if (Notification.permission === 'granted') {
        const n = new Notification(title, options);
        n.onclick = (event) => {
          let url;
          if (payload.data?.page && payload.data?.id) {
            url = `https://staging-cu.reposenergy.com/${payload.data.page === 'asset' ? 
                'allDatumOrders/New?asset_id=' : payload.data.page === 'order' ? 'myOrders' : payload.data.page}${payload.data.id}`;
          } else if (payload.data?.deep_link) {
            url = payload.data.deep_link;
          }
          if (url) {
            window.open(url, '_blank');
          }
        };
      }
      // Custom React notification card
      let deepLink = payload.notification?.image;
      if (payload.data && payload.data.page && payload.data.id) {
        deepLink = `${REACT_APP_FCM_URL}${payload.data.page === 'asset' ?
            'allDatumOrders/New?asset_id=' : payload.data.page === 'order' ? 'myOrders' : payload.data.page}${payload.data.id}`;
      } else if (payload.data && payload.data.deep_link) {
        deepLink = payload.data.deep_link;
      }
      setNotification({
        title: payload.notification?.title || payload.data?.title,
        body: payload.notification?.body || payload.data?.body,
        image: payload.notification?.image || payload.data?.image,
        deepLink
      });
      
      // Dispatch the refresh action if notification is related to Datum
      if (payload.data?.page === 'asset' || 
          (payload.notification?.title && payload.notification.title.toLowerCase().includes('datum')) ||
          (payload.data?.title && payload.data.title.toLowerCase().includes('datum'))) {
        // Dispatch Redux action to refresh DatumOrders
        dispatch(refreshDatumOrders());
      }
      
      // Auto-dismiss after 8s
      setTimeout(() => setNotification(null), 8000);
      console.log("FCM Foreground Message:", payload);
    });
  }, [dispatch]);

  return notification ? (
    <div style={{ position: 'fixed', top: 24, right: 24, zIndex: 9999 }}>
      <FCMNotificationCard
        title={notification.title}
        body={notification.body}
        image={notification.image}
        deepLink={notification.deepLink}
        onClose={() => setNotification(null)}
      />
    </div>
  ) : null;
}
